import SVGIcon from '../SVGIcon';

interface Props {
  width: string;
  height: string;
}

function TriangleExclamationIcon({ width, height }: Props) {
  return (
    <SVGIcon width={width} height={height} viewBox="0 0 160 160" fill="none">
      <path
        id="Vector"
        d="M80 16.0938L75.625 23.5938L15.625 127.5L11.4062 135H148.594L144.375 127.5L84.375 23.5938L80 16.0938ZM80 36.0938L131.25 125H28.75L80 36.0938ZM75 70V100H85V70H75ZM75 105V115H85V105H75Z"
        fill="#F59E0B"
      />
    </SVGIcon>
  );
}

export default TriangleExclamationIcon;
